import { BankAccountTimelineEvent } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/bankAccountTimeline.types.ts';
import { HistoryTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/HistoryTab.tsx';
import { ParticipantDetailsTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/ParticipantDetailsTab.tsx';
import { ReviewPanelTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/ReviewPanel.types.ts';
import { DetailsSidePanelTabs } from '@dealstack/frontend/shared/layout/DetailsPanels/DetailsSidePanelTabs.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';

interface Props {
	personId: string;
	timelineEvents: BankAccountTimelineEvent[];
	isHistoryLoading: boolean;
	activeTab: ReviewPanelTab;
	onTabChange: (tab: ReviewPanelTab) => void;
	selectedEventId?: string;
	onSelectEvent: (eventId: string) => void;
}

/** Leading panel: who the account belongs to, or how it got to its current state. */
export const ReviewPanel = ({
	personId,
	timelineEvents,
	isHistoryLoading,
	activeTab,
	onTabChange,
	selectedEventId,
	onSelectEvent,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<DetailsSidePanelTabs<ReviewPanelTab>
			value={activeTab}
			onTabChange={(value) =>
				onTabChange(
					value === ReviewPanelTab.HISTORY
						? ReviewPanelTab.HISTORY
						: ReviewPanelTab.REVIEW
				)
			}
			tabs={[
				{
					label: tMipManage('bank_accounts.details.tabs.review'),
					value: ReviewPanelTab.REVIEW,
					testId: TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_REVIEW_TAB,
				},
				{
					label: tMipManage('bank_accounts.details.tabs.history'),
					value: ReviewPanelTab.HISTORY,
					testId: TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_HISTORY_TAB,
				},
			]}
			panels={[
				{
					value: ReviewPanelTab.REVIEW,
					content: <ParticipantDetailsTab personId={personId} />,
				},
				{
					value: ReviewPanelTab.HISTORY,
					content: (
						<HistoryTab
							events={timelineEvents}
							isLoading={isHistoryLoading}
							selectedEventId={selectedEventId}
							onSelectEvent={onSelectEvent}
						/>
					),
				},
			]}
		/>
	);
};
